module.exports = __webpack_public_path__ + "static/media/STARTUP_STATION_HEADER-min.fefce145.png";